exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "app-field-inventory {\n  padding: 8px; }\n  app-field-inventory .mat-card-header-text {\n    margin: 0; }\n  app-field-inventory .stats {\n    margin-top: 20px;\n    margin-bottom: 20px; }\n  app-field-inventory .hidden {\n    visibility: hidden; }\n", ""]);

// exports
